export default __webpack_public_path__ + "static/media/checkbox-unchecked@2x.181ab32a.png";